import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { BaseButton } from '../button';
import styles from './styles.module.css';
export const BreadcrumbsItem = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    children,
    currentPage,
    breadcrumbIndex,
    addSEOAttributes = true,
    ...rest
  } = props;
  const ownClassName = clsx(styles.breadcrumbsItem, className);
  return /*#__PURE__*/React.createElement(BaseButton, {
    ref: ref,
    className: ownClassName,
    "aria-current": currentPage ? 'page' : undefined,
    ...(addSEOAttributes && {
      itemProp: 'item'
    }),
    withExtraClickZone: true,
    ...rest
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.breadcrumbsItemNameWrap
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.breadcrumbsItemName,
    ...(addSEOAttributes && {
      itemProp: 'name'
    }),
    "data-testid": "breadcrumbItemName"
  }, children), addSEOAttributes && breadcrumbIndex && (/*#__PURE__*/React.createElement("meta", {
    itemProp: "position",
    content: breadcrumbIndex.toString()
  }))));
});